











import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class Head extends Vue {}
